import { Box } from '@apia/theme';
import React from 'react';
import {
  TResponsiveTableCell,
  TResponsiveTableColumn,
  TResponsiveTableRow,
} from '../types';
import { IAccordionElementButton } from '../../../AccordionElementButton';

export type TAccordionCellRendererProps<CellProps = Record<string, unknown>> = {
  cell: TResponsiveTableCell<CellProps>;
  column: TResponsiveTableColumn;
  columnIndex: number;
  row: TResponsiveTableRow;
  rowIndex: number;
  className?: string;
};

export type TAccordionCellRenderer<CellProps = Record<string, unknown>> =
  React.FunctionComponent<TAccordionCellRendererProps<CellProps>>;

export type TAccordionCellButtonRenderer = React.FunctionComponent<
  IAccordionElementButton & {
    row: TResponsiveTableRow;
    rowIndex: number;
    columns?: TResponsiveTableColumn[];
  }
>;

const AccordionCell: TAccordionCellRenderer = ({ cell, column }) => {
  return (
    <Box
      key={column.name}
      className="responsiveTable__accordionElement__column"
    >
      <Box as="strong">
        {column.label.trim() !== '' ? `${column.label ?? column.name}: ` : ''}
      </Box>
      <Box as="span">{cell?.children}</Box>
    </Box>
  );
};

export default AccordionCell;
